import { useMemo } from 'react'
import { DayOfWeekType } from 'lib/daysOfWeek'

const useConfirmAddedHolidays = (confirmHolidays: DayOfWeekType[], holidays: DayOfWeekType[]): DayOfWeekType[] => {
  return useMemo(() => {
    return confirmHolidays.filter((confirmHoliday) => !holidays.includes(confirmHoliday))
  }, [confirmHolidays, holidays])
}

export default useConfirmAddedHolidays
